'use strict'
import _ from 'lodash'
import store from '../store'

function getToken() {
  return store.getters['mobile/mobileToken'] || ''
}

require('dotenv').config();
import configurazioni from './configurazioniService'
import moment from 'moment'
const service = process.env.VUE_APP_service_licenze || ''

const defPagamento = {
  condizioni: 'TP02',
  dettaglio: {
    modalita: 'MP01'
  }
}

// Il layout di stampa (ordineCliente_01) dereferenzia documento.totali e documento.spese
// senza guardie: se mancano, il documento si stampa con le righe vuote finché non lo si
// riapre e salva da backoffice. Riproduce i valori di documenti.js/calcolaTotaliAliquote_v2
// nel caso semplice dell'ordine da mobile: niente spese, sconto in fattura o omaggi.
const calcolaTotali = function (righe) {
  const totali = {}
  const generale = {
    imponibile: 0,
    nettoMerce: 0,
    totaleMerce: 0,
    spese: 0,
    iva: 0,
    importo: 0,
    quantita: 0,
    speseDocumentate: 0
  }
  for (const riga of righe) {
    if (riga.rigaDescrittiva || !riga.valore) continue
    const codice = _.get(riga, 'aliquotaIva.codice', '')
    const aliquota = parseFloat(_.get(riga, 'aliquotaIva.valore', 0)) || 0
    const netto = parseFloat(riga.valore.importoNettoTotale) || 0
    const quantita = parseFloat(riga.quantita) || 0
    const t = totali[`iva_${codice}`] || {
      merce: 0,
      spese: 0,
      imponibile: 0,
      ivaCodice: codice,
      iva: 0,
      ivaOmaggi: 0,
      importoOmaggi: 0,
      importo: 0,
      aliquota: String(aliquota),
      quantita: 0
    }
    t.merce += netto
    t.imponibile += netto
    t.quantita += quantita
    totali[`iva_${codice}`] = t
    generale.nettoMerce += netto
    generale.totaleMerce += netto
    generale.imponibile += netto
    generale.quantita += quantita
  }
  // Come nel backoffice: iva e importo si ricalcolano dall'imponibile per aliquota
  let totaleIva = 0
  let totaleImporto = 0
  for (const chiave of Object.keys(totali)) {
    const al = totali[chiave]
    al.iva = +((al.imponibile * parseFloat(al.aliquota)) / 100).toFixed(2)
    al.importo = +(al.imponibile + al.iva).toFixed(2)
    al.imponibile = +al.imponibile.toFixed(2)
    al.merce = +al.merce.toFixed(2)
    totaleIva += al.iva
    totaleImporto += al.importo
  }
  generale.iva = +totaleIva.toFixed(2)
  generale.importo = +totaleImporto.toFixed(2)
  generale.imponibile = +generale.imponibile.toFixed(2)
  generale.nettoMerce = +generale.nettoMerce.toFixed(2)
  generale.totaleMerce = +generale.totaleMerce.toFixed(2)
  totali.generale = generale
  return totali
}

const creaOrdineWeb = async (base, tipoDocumento, cliente, righe, payload, istanzaDb) => {
  const listini = await configurazioni.getConfigurazione(base, 'listini', 'listini', istanzaDb)
  const elenco = await configurazioni.getConfigurazione(base, 'documenti_parametri', 'tipiDocumento', istanzaDb)
  const infoTipo = elenco.find(x => x.codice === tipoDocumento)
  if (!infoTipo) return null // TODO: gestire errore e tipo
  const dataDocumento = new Date()
  const annoRiferimento = dataDocumento.getFullYear()
  const numeroDocumento = await configurazioni.getNumeratore(base, infoTipo.numeratore, true, annoRiferimento, istanzaDb)
  let destinazione = cliente.recapiti.find(x => x.tipo.default)
  if (!destinazione) {
    destinazione = cliente.recapiti.find(x => x.tipo.codice === 'principale')
  }
  // if (!destinazione) return null // TODO: gestire errore e tipo, verificare cosa succede se bypasso errore
  const pagamento = _.get(cliente, 'amministrativi.pagamento', defPagamento) 
  let testata = {
    _id: numeroDocumento,
    codice: numeroDocumento,
    data: dataDocumento,
    tipoDocumento: infoTipo,
    anagrafica: {
      cliente: {
        codice: cliente.codice,
        descrizione: cliente.ragioneSociale,
        amministrativi: cliente.amministrativi,
        fatturazione: cliente.fatturazione
      }
    },
    pagamento: pagamento,
    spedizione: {
      destinazione: destinazione || {}
    },
    righe: []
  }
  if (payload) {
    if (payload.dataConsegna) {
      testata.note = 'Data consegna: ' + moment(payload.dataConsegna, 'YYYY-MM-DD').format('DD/MM/YYYY') + '\n'
    }
    if (payload.note) {
      testata.note = (testata.note || '') + payload.note
    }
    testata.payload = payload
  }
  for (const rr of righe) {
    // attenzione alle note valorizzate o da riportare in fattura
    const rigaDocumento = {}
    if (rr.codice && rr.codice.toLowerCase() !== 'notalibera') {
      rigaDocumento.rigaDescrittiva = false
      rigaDocumento.prodotto = {
        codice: rr.codice
      }
      rigaDocumento.tipo = rr.tipo || 'prodotto'
      rigaDocumento.tipoBene = rr.tipoBene || 'PRODOTTO'
      rigaDocumento.repartoFiscale = rr.repartoFiscale || ''
    } else {
      rigaDocumento.rigaDescrittiva = true
    }
    rigaDocumento.descrizione = rr.descrizione
    rigaDocumento.quantita = rr.quantita || 0
    rigaDocumento.unitaMisura = rr.unitaMisura || ''
    rigaDocumento.sconti = rr.sconti || ''
    if (rr.iva) {
      rigaDocumento.aliquotaIva = {
        codice: rr.iva.codice,
        valore: rr.iva.valore || rr.iva.aliquota,
        descrizione: rr.iva.descrizione,
        tipoApplicazione: rr.iva.tipoApplicazione || 'banco'
      }
    }
    const listino = listini.find(x => x.codice === (rr.infoPrezzo.listino || 'L1'))
    // Calcolare importi
    if (rr.prezzoUnitario) {
      rigaDocumento.valore = {
        listino: listino,
        // verificare come inserire gli sconti
        sconto1: rr.infoPrezzo.scontoP || '', // Valore percentuale
        sconto2: '',
        sconto3: '',
        sconto4: null
      }
      var pz
      const iva = +(_.get(rr, 'iva.valore', 22) / 100).toFixed(2)
      if (listino.ivato) {
        // TODO: rivedere gli arrotondamenti come fatture !!
        pz = {
          prezzoUnitario: rr.infoPrezzo.prezzoListino,
          prezzoTotale: +(rr.infoPrezzo.prezzoListino * rr.quantita).toFixed(2),
          importoUnitario: rr.prezzoUnitario,
          importoTotale: rr.prezzo
        }
        pz.prezzoNettoUnitario = +(pz.prezzoUnitario / (1 + iva)).toFixed(2),
        pz.prezzoNettoTotale = +(pz.prezzoNettoUnitario * rr.quantita).toFixed(2)
        pz.importoNettoUnitario = +(pz.importoUnitario / (1 + iva)).toFixed(2),
        pz.importoNettoTotale = +(pz.importoNettoUnitario * rr.quantita).toFixed(2)      
      } else {
        pz = {
          prezzoNettoUnitario: rr.infoPrezzo.prezzoListino,
          prezzoNettoTotale: +(rr.infoPrezzo.prezzoListino * rr.quantita).toFixed(2),
          importoNettoUnitario: rr.prezzoUnitario,
          importoNettoTotale: rr.prezzo
        }
        pz.prezzoUnitario = +(pz.prezzoNettoUnitario * (1 + iva)).toFixed(2),
        pz.prezzoTotale = +(pz.prezzoUnitario * rr.quantita).toFixed(2)
        pz.importoUnitario = +(pz.importoNettoUnitario * (1 + iva)).toFixed(2),
        pz.importoTotale = +(pz.importoUnitario * rr.quantita).toFixed(2)    
      }
      rigaDocumento.valore = _.merge(rigaDocumento.valore, pz)
    }
    testata.righe.push(rigaDocumento)
  }
  testata.spese = []
  testata.totali = calcolaTotali(testata.righe)
  return await salvaDocumento(base, testata, istanzaDb)
}

const salvaDocumento = async function (base, dati, istanzaDb) {
  try {
    const data = {
      base,
      dati,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/documenti/documento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('salvaDocumento', err)
  }
}


export default {
  creaOrdineWeb,
  salvaDocumento
}
